// src/components/blog/BlogCard.jsx
import React from "react";
import {
  Box,
  Image,
  Heading,
  Text,
  HStack,
  Badge,
  Stack,
  Button,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const COMPANY_LABEL = {
  TAG: "Tax Advocate Group",
  WYNN: "Wynn Tax Solutions",
  ATS: "American Tax Support",
  AMITY: "Amity Tax Group",
  TGC: "Tax Group Consultants",
};

export default function BlogCard({ item }) {
  const cardBg = { base: "white", _dark: "gray.800" };
  const sub = { base: "gray.600", _dark: "gray.300" };

  if (!item) return null;

  return (
    <Box bg={cardBg} borderWidth="1px" rounded="lg" overflow="hidden">
      {item.heroImage ? (
        <Image
          src={item.heroImage}
          alt={item.title}
          w="100%"
          h="180px"
          objectFit="cover"
        />
      ) : null}

      <Stack spacing={3} p={4}>
        <HStack spacing={2} wrap="wrap">
          {item.companyKey ? (
            <Badge>{COMPANY_LABEL[item.companyKey] || item.companyKey}</Badge>
          ) : null}
          {(item.taxTypes || []).slice(0, 3).map((t) => (
            <Badge key={t} colorScheme="blue" variant="subtle">
              {t.replace(/_/g, " ")}
            </Badge>
          ))}
        </HStack>

        <Heading as="h3" size="md" noOfLines={2}>
          <RouterLink to={`/blogs/${item.slug}`}>{item.title}</RouterLink>
        </Heading>

        {item.excerpt ? (
          <Text color={sub} noOfLines={3}>
            {item.excerpt}
          </Text>
        ) : null}

        <HStack pt={2} justify="space-between">
          <Button
            as={RouterLink}
            to={`/tax-relief-blog/${item.slug}`}
            size="sm"
            colorScheme="blue"
          >
            Read
          </Button>
        </HStack>
      </Stack>
    </Box>
  );
}
